// Legacy redirects for finance routes.
// Preserves bookmarks from before the /finance/* prefix migration (F10).
// Each redirect uses `replace` so the old path does not remain in browser history.

import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';

// Dynamic redirects that carry route params forward.
const RedirectWatchlistTicker: React.FC = () => {
  const { ticker } = useParams<{ ticker: string }>();
  return <Navigate to={`/finance/watchlist/${ticker ?? ''}`} replace />;
};

const RedirectPortfolioDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/finance/portfolios/${id ?? ''}`} replace />;
};

export const financeRedirects: RouteObject[] = [
  { path: '/trading', element: <Navigate to="/finance/trading" replace /> },
  { path: '/strategies', element: <Navigate to="/finance/strategies" replace /> },
  { path: '/portfolio', element: <Navigate to="/finance/portfolio" replace /> },
  { path: '/watchlist', element: <Navigate to="/finance/watchlist" replace /> },
  { path: '/watchlist/:ticker', element: <RedirectWatchlistTicker /> },
  { path: '/portfolios', element: <Navigate to="/finance/portfolios" replace /> },
  { path: '/portfolios/:id', element: <RedirectPortfolioDetail /> },
];
